import { CustomerListView } from "./CustomersPage";

export function TrustedAdvisorPage() {
  return <CustomerListView source="trusted_advisor" title="Trusted Advisor" countLabel="Findings" />;
}
